// src/Home.js
import React, { useState, useEffect,  } from 'react';
import Slider from 'react-slick';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import DataService from '../../services/data.service';
import AnimateOnScroll from './../../components/common/animate';
import { useMemo } from 'react';
import LoaderOverlay from '../common/loader.component';

export default function Home() {
   const [loading, setLoading] = useState(false);
 
        const testimonials = [
      {
        text: "Nisha is amazing!! She’s professional yet sensitive and polite. I got a facial done from and have lived in Regina long enough to know she’s one of the best in her skills in the city along with inviting smile and great prices! The place is also very hygienic and relaxing. Highly recommend her to everyone and will keep going back to her.",
        name: "Sunia Sandhu",
        position: "Customer",
      },
      {
        text: "This was my second visit to Nisha for hairstyling, and once again, she did an incredible job. I absolutely loved her work! Her dedication to providing excellent service is truly commendable. She was incredibly patient and kind throughout the process. I highly recommend her services to everyone!",
        name: "Chithra",
        position: "Customer",
      },
      {
        text: "The services at Divine Blush Beauty are truly great. Nisha is professional and friendly. She provides home like comfortable atmosphere. I went for eyebrows and waxing. I feel completely satisfied and would highly recommend her for salon services.",
        name: "Shalini Arora",
        position: "Customer",
      },
      {
        text: "Nishu is really professional in what she does. I took several services from her and I feel highly satisfied with her work every time. She is gentle, professional and fun at the same time. Her place is tidy at all times. She is very cooperative with booking times. I will continue to be her client in future for her excellent work. She is really good.",
        name: "Naman Jeet",
        position: "Customer",
      },
      {
        text: "Had a wonderful experience at Divine Blush Beauty! I went for facial and threading as my skin is very sensitive, so I was scared to do it, but Nisha had lots of experience with skin care, and she did a fantastic job. She is very professional and friendly. I will definitely go again 😊",
        name: "Ramandeep Punia",
        position: "Customer",
      },
    ];
     const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
    {
      breakpoint: 768, // screen width less than 768px
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
      };

        const [page, setPage] = useState([]);
        const [reviews, setReviews] = useState([]);
       
        //  const fetchReviews = () => {
        //    setLoading(true);
        //    DataService.getReviews()
        //      .then((response) => {
        //        console.log(response.data.data)
        //        setReviews(response.data.data);
               
        //      })
        //      .catch((error) => {
        //        console.error('Failed to fetch reviews:', error);
        //      })
        //      .finally(() => setLoading(false));
        //  };

      const getPages = (date) => {
         setLoading(true)
          DataService.getPages(date)
            .then((response) => {
      
              let pages = response.data
              const about = pages.find(
                (page) => page.page_name === "About"
              );
              
             setPage(about);
          //  fetchReviews();
             
      setLoading(false)
            })
            .catch((error) => {
               setLoading(false)
              console.error('Failed to fetch services:', error);
            })
            .finally();
        };

       useEffect(() => {
        fetchVisitorStats();
           getPages();

    const setFullHeight = () => {
      $('.js-fullheight').css('height', window.innerHeight);
    };
    setFullHeight();
    window.addEventListener('resize', setFullHeight);
    

    // Cleanup
    return () => {
      window.removeEventListener('resize', setFullHeight);
    };
  }, []);
    const fetchVisitorStats = async () => {
      try {
        const response = await DataService.getVisitorStats();
        setVisitors({
          today: response.data.today_unique_visitors,
          total: response.data.total_unique_visitors,
        });
      } catch (error) {
        console.error('Error fetching visitor stats:', error);
      }
    };
     const plainText = useMemo(() => {
  const tempEl = document.createElement("div");
  tempEl.innerHTML = page?.message || "";
  return tempEl.textContent?.substring(0, 200) + "...";
}, [page?.message]);
  
  return (
    
    <>
      <LoaderOverlay loading={loading} />
   
    <Helmet>
      <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BeautySalon",
              "name": "Divine Blush Beauty",
              "url": "https://divineblushbeauty.ca",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "3104, Crossbie Cres",
                "addressLocality": "Regina",
                "addressRegion": "SK",
                "postalCode": "S4V3S2",
                "addressCountry": "CA"
              },
              "description": "Best salon in Regina offering facials, hair services, and more.",
              "telephone": "+1 639-915-0949"
            }
          `}
        </script>
        <title>Makeup and Hair | Regina SK - Divine Blush Beauty</title>
      <meta name="description" content="Looking for the best salon in Regina? Divine Blush Beauty offers top beauty treatments, facials, and hair services in Regina." />
        <link rel="canonical" href="https://www.divineblushbeauty.ca/" />
          <link rel="icon" href="/favicon.ico" type="image/x-icon" />

      </Helmet>
   <section className="hero-wrap js-fullheight" style={{"background-image":"url('images/topBannerImg.jpeg')"}} data-stellar-background-ratio="0.5">
    <div className="container">
      <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
		 <AnimateOnScroll className='col-md-10  text-center'>

			
          <div className="icon banner-logo"> 
            <img src="images/Logo_salon.svg" alt="Divine Blush Beauty Salon Logo"></img>
          </div>
          <h1>Divine Blush Beauty</h1>
          <div className="row justify-content-center">
            <div className="col-md-8 mb-3">
              <p>Nestled between moments of stillness and self-care, our salon is where timeless beauty and modern artistry meet, welcoming you to relax, refresh, and renew.</p>
            </div>
          </div>
          <p>
            <Link className="btn btn-primary p-3 px-5 py-4 mr-md-2" to="/book-appointment">
            Make an Appointment
            </Link>
            <Link className="btn btn-outline-primary p-3 px-5 py-4 ml-md-2" to="/contact">
            Contact
            </Link>
           
          </p>
       
		 </AnimateOnScroll>
       
      </div>
    </div>
  </section>
  <section className="ftco-section ftco-intro">
    <div className="container">
      <div className="row justify-content-end">
        <div className="col-md-5">
          <div className="img_about">
            <img src="images/About_Divine.jpg" alt="about_" />
          </div>						
        </div>
        <div className="col-md-7">
			 <AnimateOnScroll className='heading-section '>
            <h3 className="subheading">About us</h3>
            <h2 className="mb-4">About Divine Blush Beauty</h2>
	{page?.message && (
  <p>{plainText}</p>
)}
          <p>
            
             <Link className="btn btn-primary p-3 px-5 py-4 mr-md-2" to="/about">
                        Read more
                        
</Link></p>
			 </AnimateOnScroll>
        
          
        </div>
      </div>
    </div>
  </section>
  <section className="ftco-section section-services">
    <div className="container-fluid px-md-5">
      <div className="row justify-content-center mb-5 pb-3">
		 <AnimateOnScroll className="col-md-12 heading-section  text-center">
			 <h3 className="subheading">Services</h3>
          <h2 className="mb-1">Our offered services</h2>
		 </AnimateOnScroll>
        <div >
         
        </div>
      </div>
      <div className="row align-items-center">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-1">
                <img src="images/threading-Img.jpg" alt="image-1" />
                <div className="overlay-text-effect-3 overlay-text-2">
                  <h3 className="overlay-heading">Threading</h3>
                  <p>Threading That Turns Heads</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-1">
                <img src="images/waxing-img.jpg" alt="image-1" />
                <div className="overlay-text-effect-3 overlay-text-2">
                  <h3 className="overlay-heading">Waxing</h3>
                  <p>Smooth Skin Starts Here</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-1">
                <img src="images/facial-Img.jpg" alt="image-1" />
                <div className="overlay-text-effect-3 overlay-text-2">
                  <h3 className="overlay-heading">Facial &amp; Packs</h3>
                  <p>Glow Begins with a Touch</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-1">
                <img src="images/makeup-Img.jpg" alt="image-1" />
                <div className="overlay-text-effect-3 overlay-text-2">
                  <h3 className="overlay-heading">Makeup &amp; Hairstyles</h3>
                  <p></p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-11">
                {/* <img src="images/threading-Img.jpg" alt="image-1"> */}
                <div className="overlay-text-effect-3 overlay-text-2">
                  <p>Something Beautiful is Coming Soon</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
              <div className="effect-image-1">
                <img src="images/mani-Img.jpg" alt="image-1" />
                <div className="overlay-text-effect-3 overlay-text-2">
                  <h3 className="overlay-heading">Mani / Pedi</h3>
                  <p>Polished Hands. Perfect Toes</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 
  <section className="ftco-section testimony-section">
      <div className="container">
        <div className="row justify-content-center mb-5 pb-3">
			 <AnimateOnScroll className="col-md-12 heading-section  text-center">
			<h3 className="subheading">Testimony</h3>
            <h2 className="mb-1">Successful Stories</h2>
			 </AnimateOnScroll>
        </div>
		 <AnimateOnScroll className="row">
          <div className="col-md-12">
            <Slider {...settings}>
              {testimonials.map(({ text, name }, index) => (
                <div key={index}>
                  <div className="testimony-wrap p-4 pb-5">
                    <div className="text">
                      <div className="line pl-5">
                        <p className="mb-4 pb-1">{text}</p>
                        <span className="quote d-flex align-items-center justify-content-center">
                          <i className="icon-quote-left" />
                        </span>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="user-img" />
                        <div className="ml-4">
                          <p className="name">{name}</p>
                          {/* <span className="position">{position}</span> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
   
		 </AnimateOnScroll>
		
        
      </div>
    </section>

   </>
  );
}
